import { Card, CardContent, IconButton, Stack, Tooltip } from '@mui/material'
import { useTranslate } from '@tolgee/react'
import { BinIcon, EditIcon, VesselFrontIcon } from '@tom-ui/ui'
import { YardNodeHeaderTitle } from '../atoms/YardNodeHeaderTitle'

interface Props {
  id: string
  name: string
  maxDraft: number
  quayMeterMarkFrom: number
  quayMeterMarkTo: number
  bollardsCount: number
  focused: boolean
  isEditable: boolean
  onEdit: (id: string) => void
  onDelete: (id: string) => void
}
export const BerthHeader = ({
  name,
  maxDraft,
  quayMeterMarkFrom,
  quayMeterMarkTo,
  bollardsCount,
  focused,
  isEditable,
  id,
  onEdit,
  onDelete,
}: Props) => {
  const { t } = useTranslate()

  return (
    <Card>
      <CardContent sx={{ padding: '4px !important' }}>
        <Stack spacing={2} direction='row' alignItems='center' justifyContent='space-between'>
          <YardNodeHeaderTitle title={name} icon={<VesselFrontIcon />} />

          {focused && (
            <>
              <YardNodeHeaderTitle
                title={`${maxDraft}m`}
                description={`${t('maxDraft', 'Max draft')}:`}
              />

              <YardNodeHeaderTitle
                title={`${quayMeterMarkFrom} - ${quayMeterMarkTo}`}
                description={`${t('quayMeterMark', 'Quay meter mark')}:`}
              />

              <YardNodeHeaderTitle
                title={`${bollardsCount}`}
                description={`${t('bollards', 'Bollards')}:`}
              />
            </>
          )}

          {focused && isEditable && (
            <>
              <Tooltip title={t('edit', 'Edit')}>
                <IconButton onClick={() => onEdit(id)}>
                  <EditIcon />
                </IconButton>
              </Tooltip>
              <Tooltip title={t('delete', 'Delete')}>
                <IconButton onClick={() => onDelete(id)}>
                  <BinIcon />
                </IconButton>
              </Tooltip>
            </>
          )}
        </Stack>
      </CardContent>
    </Card>
  )
}
